import { useApiQuery } from '~/hooks';
import { getContactsApi, getContactStatsApi } from '../repository';
import type { ContactFilters } from '../repository/contact';
import { keepPreviousData } from '@tanstack/react-query';

export const CONTACT_QUERY_KEYS = {
  CONTACTS: 'contacts',
  CONTACT_STATS: 'contact-stats',
};

/**
 * Query hook to fetch paginated contacts
 *
 * @param filters - Optional filters for contacts
 * @returns React Query result with paginated contacts
 */
export const useGetContactsQuery = (filters?: ContactFilters) => {
  return useApiQuery({
    queryKey: [CONTACT_QUERY_KEYS.CONTACTS, filters],
    queryFn: () => getContactsApi(filters),
    placeholderData: keepPreviousData,
  });
};

/**
 * Query hook to fetch contact statistics
 *
 * @returns React Query result with contact statistics
 */
export const useGetContactStatsQuery = () => {
  return useApiQuery({
    queryKey: [CONTACT_QUERY_KEYS.CONTACT_STATS],
    queryFn: () => getContactStatsApi(),
  });
};
